import * as React from 'react';
import * as styles from './styles.scss';
import { Callout } from '@fluentui/react/lib/Callout';
import { clearButtonText } from 'owa-locstrings/lib/strings/clearbuttontext.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { FocusTrapZone } from '@fluentui/react/lib/FocusTrapZone';
import { observer } from 'mobx-react-lite';
import { searchFilters } from '../../selectors/searchFilters';
import { searchLabel } from 'owa-locstrings/lib/strings/searchlabel.locstring.json';
import { searchRefinersButtonTitle } from 'owa-locstrings/lib/strings/searchrefinersbuttontitle.locstring.json';
import CheckboxSearchRefiner from './CheckboxSearchRefiner';
import DatePickerSearchRefiner from './DatePickerSearchRefiner';
import DropdownSearchRefiner from './DropdownSearchRefiner';
import loc from 'owa-localize';
import useSearchRefinersState from '../../hooks/useSearchRefinersState';

export default observer(function SearchRefiners() {
    const {
        refinersVisible,
        onFilterButtonClicked,
        onSearchButtonClicked,
        onClearFiltersButtonClicked,
        refinersButton,
    } = useSearchRefinersState();

    const searchFilterOptions = [...searchFilters().values()];
    if (searchFilterOptions.length === 0) {
        // don't render if there aren't any filters defined
        return null;
    }

    const refiners = searchFilterOptions.map(option => {
        switch (option.type) {
            case 'Dropdown':
                return <DropdownSearchRefiner option={option} />;
            case 'Checkbox':
                return <CheckboxSearchRefiner option={option} />;
            case 'DatePicker':
                return <DatePickerSearchRefiner option={option} />;
        }
    });

    return (
        <div ref={refinersButton}>
            <IconButton
                className={styles.refinersButton}
                menuIconProps={{ iconName: ControlIcons.Filter }}
                onClick={onFilterButtonClicked}
                title={loc(searchRefinersButtonTitle)}
            />
            {refinersVisible && (
                <Callout
                    target={refinersButton}
                    setInitialFocus={true}
                    onDismiss={onFilterButtonClicked}>
                    <FocusTrapZone
                        isClickableOutsideFocusTrap={true}
                        role="listbox"
                        className={styles.searchRefinersCallout}>
                        <>
                            {...refiners}
                            <PrimaryButton
                                className={styles.primaryButton}
                                onClick={onSearchButtonClicked}
                                text={loc(searchLabel)}
                            />
                            <DefaultButton
                                className={styles.button}
                                onClick={onClearFiltersButtonClicked}
                                text={loc(clearButtonText)}
                            />
                        </>
                    </FocusTrapZone>
                </Callout>
            )}
        </div>
    );
});
